import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogActions, Button, Box, IconButton, Divider, Typography } from "@mui/material";
import { CloseDialogButtonIcon } from "../../../../../assets/icons/MUI/EventsIcons";
import { useState } from "react";
import { usePostDeleteMutation } from "../../../api/mutations/usePostDeleteMutation";

interface PostDeleteModalProps {
  open: boolean;
  onClose: () => void;
  postId: number | null;
}

export const usePostDeleteModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [postId, setPostId] = useState<number | null>(null);
  const handleOpen = (postId: number) => {
    setIsOpen(true);
    setPostId(postId);
  };
  const handleClose = () => {
    setIsOpen(false);
    setPostId(null);
  };
  return { isOpen, handleOpen, handleClose, postId };
};

export const PostDeleteModal = ({ open, onClose, postId }: PostDeleteModalProps) => {
  const { t } = useTranslation("feed", { keyPrefix: "postDeleteModal" });

  const { deletePost, isDeleting } = usePostDeleteMutation({ postId: postId as number });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "12px",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "24px 24px 20px 24px",
        }}
      >
        <Typography
          sx={{
            color: "var(--colors-text-text-primary-900, #101828)",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "28px",
          }}
        >
          {t("deletePost")}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseDialogButtonIcon />
        </IconButton>
      </Box>
      <Divider sx={{ borderColor: "#EAECF0" }} />
      <DialogContent>
        <Typography>{t("areYouSureYouWantToDeleteThisPost")}</Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px" }}>
        <Button
          type="submit"
          variant="primary-md"
          onClick={() => deletePost()}
          sx={{
            backgroundColor: "#FF0000",
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: "#FF0000",
              color: "#FFFFFF",
            },
          }}
        >
          {t("yesDelete")}
        </Button>
        <Button type="submit" variant="primary-md" onClick={onClose}>
          {t("noCancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PostDeleteModal;
